export const monthNamesShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const monthNamesFull = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const chartLegends = [
  {
    label: "Golf",
    background: "linear-gradient(180deg, #B1E3FF 0%, #6A8899 100%)",
    color: "#006AB3",
  },
  {
    label: "Baseball",
    background: "linear-gradient(180deg, #FBB900 0%, #956E00 100%)",
    color: "#94C800",
  },
  {
    label: "Athletics",
    background: "linear-gradient(180deg, #43B582 0%, #1D4F39 100%)",
    color: "#94C800",
  },
];
